import moment from 'moment';
import 'moment/locale/nb';

import WP from 'WP';

const DateFormater = props => {
    const input = props.input;
    const inputFormat = props.inputFormat || moment.ISO_8601;
    const lang = WP.lang;
    const outputFormat = props.outputFormat || 'D. MMMM YYYY';

    return moment(input, inputFormat).locale(lang).format(outputFormat)
}

export default DateFormater


// WEBPACK FOOTER //
// ./src/partials/DateFormater.js